/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Branches_Created_ToastInputs */

const en_branches_created_toast = /** @type {(inputs: Branches_Created_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branch created`)
};

const pt_br2_branches_created_toast = /** @type {(inputs: Branches_Created_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filial criada`)
};

/**
* | output |
* | --- |
* | "Branch created" |
*
* @param {Branches_Created_ToastInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const branches_created_toast = /** @type {((inputs?: Branches_Created_ToastInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Branches_Created_ToastInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_branches_created_toast(inputs)
	return pt_br2_branches_created_toast(inputs)
});